import HTTP from '@/utils/http'
import notification from '@/utils/notification'

const AppVer = 'x-app-ver'
const BuildAt = 'x-app-build-at'
const EnvName = 'x-app-env'
const prefix = 'apps'

export const getApiVer = async () => {
  let version, buildAt, envName
  try {
    const response = await HTTP.head(prefix)
    version = response.headers[AppVer]
    buildAt = response.headers[BuildAt]
    envName = response.headers[EnvName]
  } catch (err) {
    console.debug(`Failed to retrieve API version from server: ${err.message}`)
  }
  return { version, buildAt, envName }
}

export const getLanguage = async (locale) => {
  let url = `${prefix}/language/${locale}`
  try {
    // As `router.beforeEach(utils.loadSystemSettings)` is called before Loading component initialization
    // Loading component cannot listen `module_loading_startLoading` Event, so use HTTP.silentGet
    const response = await HTTP.silentGet(url)
    return response.data.data
  } catch (err) {
    notification.handleResponseError(err)
  }
}

export const getEnvSetting = async (codes, silent = true) => {
  try {
    const response = await HTTP.get(`${prefix}/envSettings`, { params: { codes } })
    return response.data.data
  } catch (err) {
    if (silent) {
      console.error(err, err.message)
    } else {
      notification.handleResponseError(err)
    }
  }
}

export const getAdInfo = async () => {
  try {
    const response = await HTTP.get(`${prefix}/adInfo`)
    return response.data.data
  } catch (err) {
    notification.handleResponseError(err)
    throw err
  }
}
